import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    padding: 0 1rem 0 1rem;
    min-width: 360px;
    .visibility {
        visibility: visible;
    }
    .gp-1{
        gap: 0.1rem;
    }
    .gp-2{
        gap: 0.2rem;
    }
    .rotating {
        transition: transform 0.3s ease-in-out;
    }
    .rotated {
        transform: rotate(180deg);
    }
    .user--out{
        display: flex;
        gap: 0.55rem;
        align-items: center;
    }
    .hideCompanies{
        max-height: 0px;
        padding: 0px;
        overflow: hidden;
    }
`;
export const Content = styled.div`
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    align-items: center;
    cursor: pointer;
    user-select: none;
    .avPef:hover{
        opacity: 0.9;
    }
`;
export const Options = styled.ul`
    position: absolute;
    display: flex;
    visibility: ${({ isOpen }) => isOpen ? 'visible,' : 'hidden'};
    z-index: 999;
    width: 350px;
    min-width: 200px;
    max-height: 400px;
    top: 48px;
    right: 0;
    left: ${({ isOpenAside }) => (isOpenAside ? '45px' : '15px')};
    flex-direction: column;
    padding: 0.45rem;
    gap: 0.33rem;
    align-items: center;
    border-radius: 12px;
    background-color: #f6f8fc;
    box-shadow: 0 4px 8px 3px rgba(0, 0, 0, .15), 0 1px 3px rgba(0, 0, 0, .3);
    user-select: none;
    > div:nth-child(1){
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: end;
        align-items: center;
        .ioClose{
            display: flex;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            color: #5f6367;
            cursor: pointer;
            &:hover{
                background-color: rgba(60,64,67,0.078);
            }
        }
    }
`;
export const Hello = styled.div`
    display: flex;
    width: calc(100% - 30px);
    max-width: calc(100% - 35px);
    justify-content: center;
    overflow: hidden;
    font-size: .899rem;
    text-overflow: ellipsis;
`;
export const Actions = styled.div`
    display: flex;
    width: 100%;
    min-height: 80px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > div  {
        display: flex;
        width: 100%;
        height: 40px;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px 0 10px;
        background-color: #ffffff;
        border-radius: 4px;

        font-weight: 500;
        font-size: .775rem;
        line-height: 20px;
        letter-spacing: normal;
        color: #495057;
        a {
            text-decoration: none;
            color: #495057;
        }
        &:hover{
            background-color: rgba(60,64,67,0.078);
        }
        cursor: pointer;

        > span {
            display: flex;
            align-items: center;
            gap: .5rem;
        }
    }

    > div:nth-child(1) {
        border-radius: 12px 12px 0 0;
    }

    > div:nth-last-child(1)  {
        border-radius: 0 0 12px 12px;
    }
`;
export const ViewerCompanies = styled.ul`
    display: flex;
    width: 100%;
    flex-direction: column;
    max-height: 128px;
    gap: 0.2rem;
    background-color: #f6f8fc;
    overflow-x: hidden;
    overflow-y: scroll;
    transition: max-height 0.101s ease-in-out;
    &::-webkit-scrollbar {
        width: 2px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
    }
`;
export const ResetPasswordStyled = styled.div`
    width: 550px;    
`;
export const User = styled.div`
    display: flex;
    align-items: center;
    min-width: 350px;
    padding: 10px;
    padding: 5px 0 5px 0;
    border-radius: 10px;
    background-color: white;
    border: 1px solid rgb(236, 237, 239);

    div {
        max-width:  ${({ isOpenAside }) => (isOpenAside ? '500px' : '240px')};
        height: 30px;
        display: flex;
        flex-direction: column;
        margin-left: 10px;
    }

    .name,
    .username {
        font-size: 1rem;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .username {
        font-size: 0.9rem;
        color: gray;
    }
`;